import e from "react";
function m() {
  const [i, r] = e.useState(!1), [s, a] = e.useState(!1), t = e.useRef(0), u = e.useCallback((n) => {
    t.current = n.clientX, r(!0);
  }, []), l = e.useCallback(
    () => {
      window.requestAnimationFrame(() => {
        a(!1), r(!1);
      });
    },
    []
  );
  return {
    dragStart: u,
    dragStop: l,
    dragMove: (n, f) => {
      const c = t.current - n.clientX, o = Math.abs(c) > 5;
      i && o && a(!0), s && o && (t.current = n.clientX, f(c));
    },
    dragging: s,
    position: t,
    setDragging: a
  };
}
export {
  m as useDrag
};
//# sourceMappingURL=useDrag.js.map
